import { RequestHeader } from './RequestHeader';
import CustomTable from '../../../../../components/table/CustomTable';
import HistoryTableApp from '../Functionality/HistoryTableApp';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const HistoryTable = ({
    optionView,
    handleBtnRequest,
    handleBtnHistory,
    setItemSelected,
    setSummaryModalShow,
    modified,
    setModified,
    setBodyForExport,
    setCriteria,
    searchElement,
    setSearchElement,
    option,
    setSearch,
    simpleSearch,
    setSimpleSearch,
    finalArray
}) => {

    const {
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        pagination,

        rowsPerPage,
        results,
        setResults,
        getData
    } = HistoryTableApp({
        setItemSelected,
        setSummaryModalShow,
        modified,
        setModified,
        searchElement,
        setBodyForExport,
        option,
        setCriteria,
        finalArray
    });

    return (
        <>
            <RequestHeader
                optionView={optionView}
                handleBtnRequest={handleBtnRequest}
                handleBtnHistory={handleBtnHistory}

                searchId={searchId}
                setBodyForExport={setBodyForExport}
                setResults={setResults}
                results={results}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                getData={getData}
            />
            <div className={"mt-3"}>
                <CustomTable
                    tableId={tableId}
                    searchId={searchId}
                    checkbox={false}
                    thead={thead}
                    tbody={tbody}
                    columnActions={true}
                    getActionsButtons={getActionsButtons}
                    textNotInformation={"you_dont_have_any_records"}
                />
                {pagination()}
            </div>
        </>
    );
};

export default HistoryTable;
